import { useRequesterStore } from '../stores/requester'
let requesterX: any

export async function createSetting(body: any) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Post({
      route: `/setting/create`,
      withAuth: true,
      body,
    })

    return resp
  } catch (e) {
    throw e
  }
}
export async function getAllSettings() {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/setting/get`,
      withAuth: true,
    })

    return resp
  } catch (e) {
    throw e
  }
}

export async function updateSetting(body: any) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Put({
      route: `/setting/update`,
      withAuth: true,
      body,
    })

    return resp
  } catch (e) {
    throw e
  }
}

export async function getEnvironments() {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/setting/environments`,
      withAuth: true,
    })

    return resp
  } catch (e) {
    throw e
  }
}
export async function sendWhatsappValidation(body: any) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Post({
      route: `/setting/send-whatsapp-validation`,
      withAuth: true,
      body,
    })

    return resp
  } catch (e) {
    throw e
  }
}
export async function sendPhoneUpdateCode(body: any) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Post({
      route: `/setting/send-phone-update-code`,
      withAuth: true,
      body,
    })
    return resp
  } catch (e) {
    throw e
  }
}

export async function verifyPhoneUpdate(code: string) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Post({
      route: `/user/verify-phone-update`,
      withAuth: true,
      body: { code },
    })
    return resp
  } catch (e) {
    throw e
  }
}

export async function getUserPhone() {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/setting/get-user-phone`,
      withAuth: true,
    })

    return resp
  } catch (e) {
    throw e
  }
}
export async function validateSRIUser(body: any) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Post({
      route: `/setting/validate-sri-user`,
      withAuth: true,
      body,
    })

    return resp
  } catch (e) {
    throw e
  }
}
export async function getSRIUser(body: any) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/setting/get-sri-user`,
      withAuth: true,
      body,
    })

    return resp
  } catch (e) {
    throw e
  }
}
